import { JobNotificationCardModel } from '../job-notification-card.model';

export class SpreadsheetExportNotificationCardModel extends JobNotificationCardModel {
  public multipleFilesFlag: boolean;
}
